export default __webpack_public_path__ + "5e73faa81b4a58a7c5b46571d82a436b.svg";